import {
  Box,
  Icon,
  Text,
  Tooltip,
  useClassNames,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'

import { cellText, gridColumnSpan } from '../../utils'

interface IHeaderCellProps {
  value: number
  span: number
}

const ALERT_TAG_VALUE = 60 * 8

const HeaderCell = ({ value, span }: IHeaderCellProps) => {
  const cx = useClassNames(stylesRefs)
  const [open, toggle] = useToggle(false)

  return (
    <Box className={cx('scheduleItemCell')} style={{ ...gridColumnSpan(span) }}>
      {value !== 0 && (
        <Box className={cx('mergedCellContent')} flexDirection="column" flexNoShrink>
          <Box flexDirection="row" alignItems="center">
            <Text.Normal size="100" weight="medium" color="grey1000" ellipsis>
              {cellText(value)}
            </Text.Normal>
          </Box>
          {value > ALERT_TAG_VALUE && (
            <Tooltip.Alt
              attachment="top center"
              open={open}
              toggle={toggle}
              label={i18n.t('project_management.schedule.alert_tag_tooltip')}
            >
              <Icon.Medium icon="alert-circle" color="radicalRed1000" />
            </Tooltip.Alt>
          )}
        </Box>
      )}
    </Box>
  )
}

export default HeaderCell
